import React, { Fragment } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Button } from 'components/Button';
import { Grid, Column } from 'components/Layout';

import CircleDeclined from 'assets/icons/circle-declined.svg';
import style from './style.scss';

const DocusignTimeout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleButtonClick = (e) => {
    e.preventDefault();
    const key = searchParams.get('key');
    navigate(`/fsl/autopayelection?key=${key}`, { replace: true });
  };

  return (
    <Fragment>
      <Header />
      <section className="container">
        <div className={cn('grid-container fluid', style['borrowers-message'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">

              <Column className="small-12 large-8 large-offset-2">
                <img src={CircleDeclined} alt="circle declined" />
                <h2>Signing document timed out</h2>
                <Button
                  className={cn('button large red', style.button)}
                  onClick={handleButtonClick}
                >
                  Click here to Esign the document
                </Button>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default DocusignTimeout;
